<template>
  <a
    id="top-banner"
    href="https://365datascience.com/?utm_medium=web&utm_source=statisticscalculators&utm_campaign=top-banner-what-gets-you-hired"
    target="_blank"
    class="top-banner no-hover"
    data-banner-content="what-gets-you-hired"
  >
    <div class="banner-container container">
      <div class="wrapper">
        <span class="text">From Statistics to AI CAREERS: </span>
        <span class="label">
          <strong>LEARN WHAT GETS YOU HIRED</strong> with <Logo />
        </span>
        <div class="label-wrapper">
          <p class="label">
            <strong>LEARN WHAT GETS YOU HIRED</strong>
          </p>
          <p>
            with <Logo />
          </p>
        </div>
      </div>
      <button class="start-button btn-primary">
        Start Now
      </button>
    </div>
  </a>
</template>

<script>
import Logo from '@itbpbg/lms-components/src/assets/svg/365-logo-v2.svg?vue-component';

export default {
  components: {
    Logo,
  },
};
</script>
<style lang="scss" scoped>
.top-banner {
  color: var(--main-dark-shade-0);
  background-image: url('../assets/images/top-banner.webp');
  height: 67px;
  padding: 14px;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;

  .banner-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .wrapper {
    .text {
      font-size: 18px;
      font-weight: 600;
    }

    .label {
      color: var(--main-light);
      background: var(--main-dark);
      padding: 6px 13px;
      border-radius: 57px;
      line-height: 120%;

      .mobile {
        display: none;
      }

      strong {
        font-size: 18px;
      }

      svg {
        width: 140px;
        height: 20px;
        vertical-align: bottom;

        path[fill] {
          fill: var(--main-light);
        }
      }
    }

    .label-wrapper {
      display: none;
    }
  }

  .start-button {
   width: 150px;
   height: 39px;
  }
}

@include bp($bp-mobile) {
  .top-banner {
    height: 169px;
    padding: 20px 24px 16px;
    background-image: url('../assets/images/top-banner-mobile.webp');

    .banner-container {
      flex-direction: column;
      padding: 0;

      .wrapper {
        text-align: center;

        .text {
          line-height: 100%;
        }

        span.label {
          display: none;
        }

        .label-wrapper {
          display: block;

          p {
            margin: 0;

            &:last-child {
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }

          .label {
            margin: 8px 0;
            height: 25px;
            line-height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            width: calc(100vw - 48px);
          }

          svg {
            margin-left: 6px;
            width: 165px;
            height: 24px;
          }
        }
      }

      .start-button {
        width: 100%;
        height: 39px;
        padding: 11px;
        margin-top: 16px;
      }
    }
  }
}
</style>
